package com.wintermar.inspection.feature.presentation.inspection.complete

sealed class InspectionCompleteEvent {
    data class NavigateToLanding(val inspectionId: String) : InspectionCompleteEvent()
    object NavigateToInspectionAnswer : InspectionCompleteEvent()
}
